import React from 'react'
import { useNavigate } from 'react-router-dom'
import SimpleAccordion from '../../ui_reusable/SimpleAccordion'
import { StandardButton } from '../../ui_reusable/styles/ButtonStyles'
import {
  SectionPanel,
  SectionHeader,
  SectionTitle,
} from './styles/ManageLearning.styles'

interface LearningSection {
  title: string
  path: string
}

const ManageLearningPage: React.FC = () => {
  const navigate = useNavigate()

  const sections: LearningSection[] = [
    { title: 'Quick-Start Intro', path: '/learning/intro' },
    { title: 'Academy', path: '/learning/academy' },
    { title: 'FAQ', path: '/learning/faq' },
  ]

  const handleNavigate = (path: string): void => {
    navigate(path)
  }

  return (
    <>
      <SimpleAccordion
        id={'learningDashboardAccordion'}
        defaultActiveKey={['1']}
      >
        <SimpleAccordion.Panel header="Learning" eventKey="1" noCollapse>
          {sections.map((section) => (
            <SectionPanel key={section.title}>
              <SectionHeader>
                <SectionTitle>{section.title}</SectionTitle>
                <StandardButton onClick={() => handleNavigate(section.path)}>
                  Modify
                </StandardButton>
              </SectionHeader>
            </SectionPanel>
          ))}
        </SimpleAccordion.Panel>
      </SimpleAccordion>
    </>
  )
}

export default ManageLearningPage
